import React, { FC } from 'react'
import { getValueListBgColor } from '../../../utils/background-util'

interface Props {
  milestoneColor: string
  contentDesc: string
  milestoneMonthDesc: string
  leftAligned: boolean
}

const RowComponent = ({ contentDesc, milestoneMonthDesc, milestoneColor, leftAligned }: Props) => {
  return (
    <div
      className={`Journey u-flex u-posRelative ${
        leftAligned ? 'u-lg-after5of12 Journey-Left' : 'u-lg-before5of12'
      }`}>
      {!leftAligned && <div className='u-size1of12 u-md-hidden u-sm-hidden' />}
      <h3
        className={`Journey-step step-right u-flex u-flexJustifyCenter u-flexAlignItemsCenter u-sizeFull u-textColorWhite ${getValueListBgColor(
          milestoneColor
        )} u-textCenter u-paddingHoriz8 u-size1of12 ${leftAligned ? 'u-lg-hidden' : ''}`}>
        {milestoneMonthDesc}
      </h3>
      <div
        className={`Journey-content u-md-Journey-content u-sm-Journey-content right-aligned u-md-size1of12 u-sm-size1of12 u-flex u-flexJustifyBetween u-paddingVert20 u-sm-paddingLeft8 u-paddingLeft32 u-posRelative u-size1of12 ${
          leftAligned ? 'u-lg-hidden' : ''
        }`}>
        <div className='Journey-text u-size10of12'>
          <div className='Content content-block'>
            <p className='cmsTextColorPurple u-textColorPurple'></p>
          </div>
        </div>
      </div>
      <div className='Journey-text u-size9of12 u-md-size10of12 u-md-marginTop8 u-marginTop20 u-sm-marginTop8'>
        <div className='Content content-block u-border u-bgColorLight u-lg-marginRight32'>
          <div className='u-paddingHoriz16 u-paddingVert32'>
            <div dangerouslySetInnerHTML={{ __html: contentDesc }}></div>
          </div>
        </div>
      </div>
      {leftAligned && (
        <>
          <div
            className={`Journey-content u-md-Journey-content u-sm-Journey-content right-aligned u-md-size1of12 u-sm-size1of12 u-flex u-flexJustifyBetween u-paddingVert20 u-sm-paddingLeft8 u-paddingLeft32 u-posRelative u-size1of12 ${
              leftAligned ? 'u-md-hidden u-sm-hidden' : ''
            }`}>
            <div className='Journey-text u-size10of12'>
              <div className='Content content-block'>
                <p className='cmsTextColorPurple u-textColorPurple'></p>
              </div>
            </div>
          </div>
          <h3
            className={`Journey-step step-right u-flex u-flexJustifyCenter u-flexAlignItemsCenter u-sizeFull u-textColorWhite ${getValueListBgColor(
              milestoneColor
            )} u-textCenter u-paddingHoriz8 u-size1of12 u-md-hidden u-sm-hidden`}>
            {milestoneMonthDesc}
          </h3>
        </>
      )}
    </div>
  )
}

export default RowComponent
